export default class GridListing {
    constructor(gd) {
        this.grid = gd;
        this.$window   = $(window);
        this.$document = $(document);
        this.year = $('#year');
        this.loadMoreBtn = $('.load--more');
        this.bindEvents();
    }

    bindEvents = () => {
        this.$page = 1;
        this.autoLoad = true;

        this.delayLoad();
        this.$window.on('scroll', this.onScroll);
        this.year.change(this.delayLoad);
    };
    onScroll = () => {
        let scrollTop = this.$window.scrollTop();
        if (this.getAutoLoader() && this.isAtBottom(scrollTop)) {
            this.nextPage();
        }
    };
    delayLoad = () => {
        this.resetPage();
        this.getCurrentGrid().empty();
        this.showLoader();
        clearTimeout(this.timer);
        this.timer = setTimeout(this.filterGrid, 1000);
    };
    nextPage = () => {
        this.showLoader();
        clearTimeout(this.timer);
        this.timer = setTimeout(this.loadMore, 1000);
    };
    loadMore = () => {
        this.addPage();
        $.ajax({
            dataType: 'json',
            type: 'GET',
            data: {
                page: this.$page,
                year: this.getYear(),
                isAjax: true
            },
            url: this.getCurrentPagePath(),
            success: this.appendItems
        });
    };
    appendItems = (response) => {
        if (response.success) {
            let $data = response.data;
            this.hideLoader();
            this.getCurrentGrid().append($data);
        } else {
            this.loadMoreBtn.addClass('hidden');
            this.hideLoader();
            this.setAutoLoader(false);
            this.autoLoad = false;
        }
    };
    filterGrid = () => {
        $.ajax({
            dataType: 'json',
            type: 'GET',
            data: {
                page: this.$page,
                year: this.getYear(),
                isAjax: true
            },
            url: this.getCurrentPagePath(),
            success: this.applyFilters
        });
    };
    applyFilters = (response) => {
        let data;
        if (this.grid.length) {
            this.setAutoLoader(true);

            if (!response.success) {
                data = `<div class="text-center not-found"><h3>No Results found</h3></div>`;
                this.loadFlag = true;
            } else {
                data = response.data;
                this.loadFlag = false;
            }
            this.loadFlag ? this.loadMoreBtn.addClass('hidden') : this.loadMoreBtn.removeClass('hidden');
            this.hideLoader();
            this.getCurrentGrid().empty();
            this.getCurrentGrid().append(data);
        }
    };
    isAtBottom = (scrollTop) => {
        return scrollTop + this.$window.height() > this.$document.height() - 350;
    };
    hideLoader = () => {
        this.loadMoreBtn.text(this.loadMoreBtn.data('text'));
    };
    showLoader = () => {
        this.loadMoreBtn.text( this.loadMoreBtn.data('loading-text'));
    };
    addPage = () => {
        this.$page += 1;
    };
    resetPage = () => {
        this.$page = 1;
    };
    getYear = () => {
        return this.year.val() ? encodeURI(this.year.val()) : '';
    };
    getAutoLoader = () => {
        return this.autoLoad;
    };
    setAutoLoader = (parameter) => {
        this.autoLoad = parameter;
    };
    getCurrentGrid = () => {
        return this.grid.find('.grid--listing');
    };

    getCurrentPagePath = () => {
        return location.href.split('?')[0];
    };

}